<template>
  <div class="tw-font-inter">
    <DesktopMenu class="max-sm:tw-hidden" />
    <MobileMenuDrawer class="sm:tw-hidden" />
  </div>
</template>

<script>
import MobileMenuDrawer from '@/v2/components/menu-drawer/mobile/MobileMenuDrawer.vue'
import DesktopMenu from '@/v2/components/menu-drawer/desktop/DesktopMenu.vue'

export default {
  name: 'MenuDrawer',
  components: {
    DesktopMenu,
    MobileMenuDrawer,
  },
}
</script>

<style scoped></style>
